var hosturl = require('url');
var adr = window.location.href;
var parseUrlName = hosturl.parse(adr, true);
var urlName = parseUrlName.host;

module.exports = {
    urlName: urlName
}